const common = { fill: "none", stroke: "currentColor", strokeWidth: 1, strokeLinecap: "round" };

export const Glyph = ({ type, className = "w-14 h-14" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true" {...common}>
    <circle cx="32" cy="32" r="30" strokeWidth="0.6" strokeDasharray="1 3" />
    {type === "moon" && <path d="M38 14a19 19 0 1 0 0 36a15 15 0 0 1 0-36z" />}
    {type === "sun" && (
      <>
        <circle cx="32" cy="32" r="9" />
        {Array.from({ length: 12 }, (_, i) => (
          <line key={i} x1="32" y1="12" x2="32" y2={i % 2 ? 17 : 19} transform={`rotate(${i * 30} 32 32)`} />
        ))}
      </>
    )}
    {type === "union" && (
      <>
        <path d="M32 12 L50 44 H14 Z" />
        <path d="M32 52 L14 20 H50 Z" />
        <circle cx="32" cy="32" r="3" fill="currentColor" stroke="none" />
      </>
    )}
  </svg>
);
